import { render, staticRenderFns } from "./BeSplashScreen.vue?vue&type=template&id=d39864d0&"
import script from "./BeSplashScreen.vue?vue&type=script&lang=js&"
export * from "./BeSplashScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports